export default __webpack_public_path__ + "static/media/30.1b91eb9d.mp3";